import styled, { css } from 'styled-components'

const StatisticsRow = styled.div`
  display: flex;
  padding: 5px 5px 5px 12px;
  width: 100%;
`

export default StatisticsRow
